define('core/event-aggregator', ['lib/underscore', 'lib/backbone'], function (_, Backbone) {
    return _.clone(Backbone.Events);
});
